import { jsxs as i, jsx as t } from "react/jsx-runtime";
import { useCallback as u } from "react";
import { c as p } from "../clsx-OuTLNxxd.js";
import { Icon as f } from "../Icon/Icon.js";
import { c as I } from "../background-CRdXfOz5.js";
const v = "AccordionItem-module_item__N6s20",
  A = "AccordionItem-module_header__vQCh-",
  N = "AccordionItem-module_title__CENXw",
  b = "AccordionItem-module_content__waG3A",
  e = {
    item: v,
    header: A,
    title: N,
    content: b
  },
  g = _ref => {
    let {
      title: l,
      id: o,
      isExpanded: c = !1,
      onToggleExpanedItem: n,
      backgroundColor: s,
      trackingName: m,
      children: d
    } = _ref;
    const r = "accordion-control-".concat(o),
      a = "accordion-content-".concat(o),
      _ = u(() => {
        n && n(o);
      }, [o, n]),
      h = I(s);
    return /* @__PURE__ */i("div", {
      className: p(e.item, h),
      "data-content-name": "accordion-".concat(m),
      children: [/* @__PURE__ */i("button", {
        className: e.header,
        onClick: _,
        "data-content-piece": c ? "collapse" : "expand",
        "aria-expanded": c,
        "aria-controls": a,
        id: r,
        children: [/* @__PURE__ */t("h3", {
          className: e.title,
          children: l
        }), /* @__PURE__ */t("div", {
          children: /* @__PURE__ */t(f, {
            name: c ? "chevron-up" : "chevron-down",
            size: "1.5x",
            padding: "inline"
          })
        })]
      }), c && /* @__PURE__ */t("div", {
        id: a,
        role: "region",
        "aria-labelledby": r,
        className: e.content,
        children: d
      })]
    });
  };
export { g as AccordionItem };